module.exports = __webpack_public_path__ + "img/M003.4f7af490.jpg";